const password = {
    unsupported_encryption_method: '暗号化方式 {{name}} はサポートされていません。',
    pepper_not_found: 'パスワードペッパーが見つかりません。コアの環境を確認してください。',
    rejected: 'パスワードが拒否されました。パスワードが要件を満たしているか確認してください。',
};
export default Object.freeze(password);
